import React from "react";
import { columns } from "../../../../dtos/columns";
import { RespuestaMorososServinco } from "../models/respuestaMorososServinco";
import { Checkbox } from "@mui/material";

interface IProps {
  controlTabla: any;
  ids: number[];
  setIds: React.Dispatch<React.SetStateAction<number[]>>;
}

export function useColumnsMorososServinco({ controlTabla, ids, setIds }: IProps) {
  const COLUMNS: columns<RespuestaMorososServinco>[] = [
    {
      name: (
        <Checkbox
          size="small"
          checked={
              controlTabla?.data?.length > 0 &&
              ids.length === controlTabla.data.length
          }
          onChange={(e) => {
              if (e.target.checked && controlTabla?.data) {
                  const allIds = controlTabla.data.map((item: RespuestaMorososServinco) => item.id);
                  setIds(allIds);
              } else {
                  setIds([]);
              }
          }}
        />
      ),
      selector: (row: RespuestaMorososServinco) => row.id,
      cell: (row: RespuestaMorososServinco) => (
          <Checkbox
              size="small"
              checked={ids.some((m) => m === row.id)}
              onChange={(e) => {
                  setIds((prev) => {
                  if (e.target.checked) {
                      // Agregar si no está
                      return [
                          ...prev,
                          row.id
                      ];
                  } else {
                      return prev.filter((id) => id !== row.id);
                  }
                  });
              }}
          />
      ),
      allowOverflow: true,
      button: true,
      export: false,
      width: '60px',
    },
    {
      name: "N° Operación",
      selector: (row: RespuestaMorososServinco) => row.numeroOperacion?.toString() || 'Desconocido',
      sortable: true,
      sortField: "numeroOperacion",
      wrap: true,
      export: true,
    },
    {
      name: "Nombre",
      selector: (row: RespuestaMorososServinco) => row.nombre?.toString() || 'Desconocido',
      sortable: true,
      sortField: "nombre",
      wrap: true,
      export: true,
    },
    {
      name: "Rut solicitante",
      selector: (row: RespuestaMorososServinco) => row.rut?.toString() || 'Desconocido',
      sortable: true,
      sortField: "rut",
      wrap: true,
      export: true,
    },
    {
      name: "Enviar a empresa cobranza (grabado en BD)",
      selector: (row: RespuestaMorososServinco) => row.enviarServinco?.toString() || '',
      sortable: true,
      sortField: "enviarServinco",
      wrap: true,
      export: true,
    },
  ]

  return { COLUMNS };
}
